import RoleDashboard from './components/RoleDashboard';

// Simple test component
export default function TestRoleDashboard() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Testing RoleDashboard Component</h1>
      <hr />
      <RoleDashboard />
    </div>
  );
}
